<div class="loading-dropdown-spinner">
  <mat-spinner matSuffix
                        diameter="20"
                        mode="indeterminate"
                        [style.marginTop.px]="getTopOffset()"
                        [style.marginRight.px]="getRightOffset()"
                        [style.marginBottom.px]="getBottomOffset()"
                        [style.marginLeft.px]="getLeftOffset()"></mat-spinner>
</div>
